import React from 'react';

import { AiFillCaretRight } from 'react-icons/ai';
import { GiCutDiamond } from 'react-icons/gi';
import { programs } from '../data';
import SectionHead from './SectionHead';
import Card from '../UI/Card';
import { Link } from 'react-router-dom';
import Image from '../images/job-interview10.jpeg'; 
import '../pages/home/home.css';

const Programs = () => {
    return (
        <section className="programs">
            <div className="programs__container">
                <div className="program__left">
                    <div className="program__image">
                        <img src={Image} alt="Job Interview" />
                    </div>
                </div>
                <div className="program__right">
                <SectionHead icon={<GiCutDiamond />} title="Reference"/>
                    <p> 
                        Discover valuable references in our video library, where past experiences come alive.
                    </p>
                    <div className="programs__wrapper">
                        {programs.map(({ id, icon, title, info, path }) => (
                            <Card className="programs__program" key={id}>
                                <span>{icon}</span>
                                <h4>{title}</h4>
                                <small>{info}</small>
                                <Link to={path} className="btn sm">
                                    Learn More <AiFillCaretRight />
                                </Link>
                            </Card>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Programs;
